import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../@pages/components/shared.module';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { pgSelectModule} from '../../@pages/components/select/select.module';
import { MessageModule } from '../../@pages/components/message/message.module';
import { MessageService } from '../../@pages/components/message/message.service';
import { ModalModule } from 'ngx-bootstrap/modal';
import { pgSwitchModule } from '../../@pages/components/switch/switch.module';
import { TextMaskModule } from 'angular2-text-mask';
import { UsersRoutes } from './users.routing';
import { ButtonLoadingModule } from '../../@pages/components/btn-loading/btn-loading.module';
import { UsersComponent } from './users-list/users-list.component';
import { ProgressModule } from '../../@pages/components/progress/progress.module';
import { pgDatePickerModule } from '../../@pages/components/datepicker/datepicker.module';
import { UserDetailComponent } from './users-detail/users-detail.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule, ReactiveFormsModule, 
    SharedModule,
    NgxDatatableModule,
    pgSelectModule,
    MessageModule,
    ModalModule,
    TextMaskModule,
    pgSwitchModule,
    pgDatePickerModule,
    RouterModule.forChild(UsersRoutes),
    ButtonLoadingModule,
    ProgressModule
  ],
  declarations: [UsersComponent, UserDetailComponent],
  providers:[MessageService]
})
export class UsersModule {
  
}
